import { Template } from '@ui/interfaces'
import { create } from 'zustand'
import { combine } from 'zustand/middleware'

interface ExporterStates {
  wizardStep: number
  template: null | Template
}

const combineDefaults: ExporterStates = {
  wizardStep: 0,
  template: null,
}

export const useExporterNodeStore = create(
  combine(combineDefaults, (set) => ({
    setWizardStep: (to: number) => {
      set(() => {
        return { wizardStep: to }
      })
    },
    setTemplate: (to: null | Template) => {
      set(() => {
        return { template: to }
      })
    },
  }))
)
